import { SkeletonTableBody } from '@neo/blocks/data-table/skeleton/table-body-skeleton'
import { cn } from '@neo/lib/utils'
import { Skeleton } from '@neo/primitives/skeleton'
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@neo/primitives/table'

export const ScenariosLoading = () => (
  <output
    aria-busy="true"
    aria-label="Loading test scenarios"
    data-testid="loading-test-scenarios"
    className="flex h-full flex-col overflow-hidden rounded-lg border border-border bg-card"
  >
    <Table aria-hidden="true">
      <TableHeader>
        <TableRow>
          <TableHead className="w-10">
            <Skeleton className="h-4 w-4" />
          </TableHead>
          <TableHead>Test scenarios</TableHead>
          <TableHead>Caller objective</TableHead>
          <TableHead className="w-[170px]">Created on</TableHead>
          <TableHead className="w-10" />
        </TableRow>
      </TableHeader>
      <TableBody>
        <SkeletonTableBody
          columnCount={5}
          rowCount={5}
          cellWidths={['40px', '30%', '40%', '170px', '40px']}
        />
      </TableBody>
    </Table>
    <div className="mt-auto flex items-center justify-between border-t border-border px-6 py-3">
      <Skeleton className="h-4 w-24" />
      <div className="flex gap-1">
        <Skeleton className="h-8 w-8" />
        <Skeleton className="h-8 w-8" />
      </div>
    </div>
  </output>
)

export const SimulationRunsLoading = ({ collapsed }: { collapsed: boolean }) => (
  <output
    aria-busy="true"
    aria-label="Loading simulation runs"
    data-testid="loading-simulation-runs"
    className={cn(collapsed && 'flex flex-col items-center gap-1 py-2')}
  >
    {['first', 'second', 'third'].map((key) =>
      collapsed ? (
        <Skeleton key={key} className="h-7 w-7" />
      ) : (
        <div key={key} className="flex flex-col gap-3 border-b border-border p-4">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-3 w-2/3" />
        </div>
      ),
    )}
  </output>
)
